import { render, staticRenderFns } from "./filters.vue?vue&type=template&id=38a7ae90&scoped=true"
import script from "./filters.ts?vue&type=script&lang=ts&external"
export * from "./filters.ts?vue&type=script&lang=ts&external"
import style0 from "./filters.scss?vue&type=style&index=0&id=38a7ae90&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a7ae90",
  null
  
)

export default component.exports